import { camelizeKeys } from '~/utils/helpers';

export class ResponseTransformer {
    constructor(data) {
        this.data = data;
    }

    camelizeKeys() {
        this.data = camelizeKeys(this.data);
    }
}
